// extracted by mini-css-extract-plugin
module.exports = {"link":"U1sF3","box-link":"_3t5Af","boxLink":"_3t5Af"};